import React from "react";
import styles from "./SuccessfulPaymentCard.module.scss";
import SuccessIcon  from "../../assets/images/payment-success.png";
import { useHistory } from "react-router-dom";
import NewSuccessIcon from "../../assets/images/payment-success.png";

type SuccessfulPaymentCardProps = {
  paymentmethod: string;
};
const SuccessfulPaymentCard = ({
  paymentmethod,
}: SuccessfulPaymentCardProps) => {
  const history = useHistory();

  // Handler to navigate to the home page
  const handleClose = () => {
    window.location.reload(); //refresh page
  };

  return (
    <div className={styles.successful_payment}>
      <img src={NewSuccessIcon} />
      <h3>Transaction Successful</h3>
      <p style={{ margin: "20px 0px" }}>
        Thank you! Your transaction was completed successfully!
      </p>
      <button
        onClick={handleClose}
        style={{
          padding: "8px",
          marginTop: "30px",
          width: "193px",
          border: "none",
          color: "white",
          borderRadius: "6px",
          background: "#8E183E",
        }}
      >
        Close
      </button>
    </div>
  );
};

export default SuccessfulPaymentCard;
